import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    paddingRight: 7,
  },
  graphHeader: {
    paddingTop: 10,
    paddingBottom: 7,
  },
  footerRow: {
    paddingBottom: 14,
  },
});
